<div class="main px-3 py-3">
  <div class="bg-grey">
  </div>
  <div class="page-header">
    <div class="title-container">
      チェーンPOS参照権限設定
    </div>
  </div>
    <mat-tab-group class="mat-tab-fill-height" animationDuration="0ms">
      <mat-tab label="参照/ダウンロード" class="label">
        <!-- 参照/ダウンロード -->
        <div class="looker-field">
          <div id="I-set-reference-controls" class="looker-embed"></div>
          <div class="download-button mt-3">
            <app-download-button style="margin-right: 3rem;"></app-download-button>
              <button mat-raised-button style="margin-right: 1rem;">アップロード申請</button>
              <button mat-raised-button>申請状況確認</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="自動付与設定" class="label">
        <!-- 自動付与設定 -->
        <div class="auto-set-field">
          <app-auto-authorization-setting-ab *ngIf="organization === 'AB'" style="width: 100%;">
          </app-auto-authorization-setting-ab>
          <app-auto-authorization-setting-asd *ngIf="organization === 'ASD'" style="width: 100%;">
          </app-auto-authorization-setting-asd>
        </div>
      </mat-tab>
      <mat-tab label="一括変更" class="label">
        <!-- 一括変更 -->
        <div class="direct-set-field">
          <app-direct-authorization-setting-ab *ngIf="organization === 'AB'" style="width: 100%;">
          </app-direct-authorization-setting-ab>
          <app-direct-authorization-setting-asd *ngIf="organization === 'ASD'" style="width: 100%;">
          </app-direct-authorization-setting-asd>
        </div>
      </mat-tab>
      <mat-tab label="変更履歴" class="label">
        <!-- 設定履歴 -->
        <div class="history-field">
          <div id="I-set-reference-controls-history" class="looker-embed"></div>
        </div>
      </mat-tab>
    </mat-tab-group>
</div>
